// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { precisionKm } from 'config/constants'
import { roundToFixed } from 'helpers/reduxFormFunctions'
import { convertBetweenKMandMI } from 'helpers/unitConversion'

// v is a value in km.
// based on the defined unitType, convert as necessary
// for display in the UI.
const valueFromKm = (v, unitType) => (
  unitType === 'SI'
    ? roundToFixed(v, precisionKm)
    : convertBetweenKMandMI(v, 'US')
)

export default valueFromKm
